
<Title>
  <slot>{{ title }}</slot>
</Title>
